import { Component } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { StatusItemAction } from '@models/imported/SagaBase';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { TranslateService } from '@ngx-translate/core';
import { StatusService } from '@services/status/status.service';
import { UnitListFetchingService } from '../../services/unit-list-fetching/unit-list-fetching.service';

@Component({
  templateUrl: './unit-activity-selector.component.html',
  styleUrls: ['./unit-activity-selector.component.scss'],
  providers: [UnitListFetchingService]
})
export class UnitActivitySelectorComponent {
  unitActivities: UnitActivity[];
  extend: boolean = false;

  constructor(
    private readonly _modalController: ModalController,
    private readonly _alertController: AlertController,
    private readonly _statusService: StatusService,
    private readonly _translateService: TranslateService,
    private readonly _unitListFetchingService: UnitListFetchingService
  ) {}

  cancel() {
    this._modalController.dismiss();
  }

  itemSelected(item: UnitActivity) {
    this._alertController
      .create({
        message: this._translateService.instant('Saga.AssociateMessage'),
        subHeader: item.rShort(),
        buttons: [
          {
            text: this._translateService.instant('Static.Cancel'),
            role: 'cancel',
            handler: () => {}
          },
          {
            text: this._translateService.instant('Saga.Associate'),
            role: 'primary',
            handler: async () => {
              this._modalController.dismiss(item);
            }
          }
        ]
      })
      .then(a => a.present());
  }

  refresh() {
    this.updateList();
  }

  ionViewWillEnter() {
    this.updateList();
  }

  private updateList() {
    const status = this._statusService.getStatusByAction(StatusItemAction.isAvailable).Value;
    this._unitListFetchingService.fetch(status).subscribe(unitActivityResource => (this.unitActivities = unitActivityResource));
  }
}
